var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"animation"}},[(_vm.visable)?_c('div',{staticClass:"loaidng",style:({ background: _vm.background })},[_c('div',{staticClass:"loading-cell flash"},[_c('img',{attrs:{"src":_vm.imgSrc}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }